import React, { lazy } from "react";
import { Switch, Route } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { componentLazyImport } from "modules/core/utils/helpers";

import { coreRoutesConstants as routesConstants } from "../routesConstants";

// Pages
const Dashboard = lazy(() =>
  componentLazyImport(() => import("../../pages/Dashboard"))
);
const AccountSettings = lazy(() =>
  componentLazyImport(() => import("../../pages/AccountSettings"))
);
const SuperAdmins = lazy(() =>
  componentLazyImport(() => import("../../pages/SuperAdmins"))
);
const AccountDetails = lazy(() =>
  componentLazyImport(() => import("../../pages/AccountDetails"))
);
const AccountModules = lazy(() =>
  componentLazyImport(() => import("../../pages/AccountModules"))
);
const ProjectGrouping = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectGrouping"))
);
const Watchtower = lazy(() =>
  componentLazyImport(() => import("../../pages/Watchtower"))
);
const WatchtowerInstance = lazy(() =>
  componentLazyImport(() => import("../../pages/WatchtowerInstance"))
);
const WatchtowerAuth = lazy(() =>
  componentLazyImport(() => import("../../pages/WatchtowerAuth"))
);

const CorePrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.dashboard.path} exact>
        <Dashboard />
      </Route>

      <Route path={routesConstants.modules_settings.path} exact>
        <AccountModules />
      </Route>

      <Route path={routesConstants.super_admins.path} exact>
        <SuperAdmins />
      </Route>

      <Route path={routesConstants.account_details.path} exact>
        <AccountDetails />
      </Route>

      <Route path={routesConstants.account_settings.path} exact>
        <AccountSettings />
      </Route>

      <Route path={routesConstants.project_grouping.path} exact>
        <ProjectGrouping />
      </Route>

      <Route path={routesConstants.watchtower_auth.path} exact>
        <WatchtowerAuth />
      </Route>

      <Route path={routesConstants.watchtower_instance.path} exact>
        <WatchtowerInstance />
      </Route>

      <Route path={routesConstants.watchtower.path} exact>
        <Watchtower />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default React.memo(CorePrivateRoutes);
